import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

export const PIPEDRIVE_FORM_URL = 'https://webforms.pipedrive.com/f/cscVs3mERbv3SF1cKlX4TF5nmssmSLFFzd82fHyCpoaaYXj3qu42zvEouDuxVAZdMD';
const PIPEDRIVE_LOADER_URL = 'https://webforms.pipedrive.com/f/loader';
const PIPEDRIVE_ORIGIN = new URL(PIPEDRIVE_FORM_URL).origin;

const Container = styled.div`
  width: 100%;
  min-width: 0;
  box-sizing: border-box;
  padding: 0 12px;

  .pipedriveWebForms {
    width: 100%;
    height: auto;
  }

  .pipedriveWebForms iframe {
    display: block;
    width: 100%;
    height: 800px;
    margin: 0 auto;
    border: 0;
  }

  .pipedrive-status {
    padding: 16px;
    text-align: center;
    color: #595959;
    line-height: 1.5;
  }

  .pipedrive-status:empty {
    padding: 0;
  }

  a {
    color: #1d73d6;
    text-decoration: underline;
  }
`;

export default function PipedriveContactForm() {
  const { t } = useTranslation();
  const hostRef = useRef(null);
  const [status, setStatus] = useState('loading');

  useEffect(() => {
    const host = hostRef.current;
    const embed = document.createElement('div');
    embed.className = 'pipedriveWebForms';
    embed.setAttribute('data-pd-webforms', PIPEDRIVE_FORM_URL);
    host.appendChild(embed);

    // Readiness comes from the form, not the loader's download or a submission.
    const handleMessage = (event) => {
      const iframe = embed.querySelector('iframe');
      const data = event.data;
      if (event.origin !== PIPEDRIVE_ORIGIN || !iframe ||
          event.source !== iframe.contentWindow || !data || typeof data !== 'object') {
        return;
      }

      const currentResize = data.type === 0 && data.payload?.uuid === embed.id &&
        Number.isFinite(data.payload.height) && data.payload.height > 0;
      const legacyResize = data.source === 'pipedriveWebForms' && data.uuid === embed.id &&
        Number.isFinite(data.formHeight) && data.formHeight > 0;
      if (currentResize || legacyResize) {
        window.clearTimeout(timeout);
        setStatus('ready');
      }
    };

    window.addEventListener('message', handleMessage);
    const timeout = window.setTimeout(() => setStatus('unavailable'), 20000);
    const script = document.createElement('script');
    script.src = PIPEDRIVE_LOADER_URL;
    script.async = true;
    script.onerror = () => {
      window.clearTimeout(timeout);
      setStatus('unavailable');
    };

    // Defer insertion so React StrictMode's discarded effect cannot load twice.
    const initialization = window.setTimeout(() => embed.appendChild(script), 0);

    return () => {
      window.clearTimeout(initialization);
      window.clearTimeout(timeout);
      window.removeEventListener('message', handleMessage);
      script.onerror = null;
      embed.remove();
    };
  }, []);

  return (
    <Container>
      <div className="pipedrive-status" role="status" aria-live="polite">
        {status === 'loading' && t('Cargando formulario de contacto...')}
        {status === 'unavailable' && (
          <>
            {t('El formulario está tardando en cargar. Puedes abrirlo directamente:')}{' '}
            <a href={PIPEDRIVE_FORM_URL} target="_blank" rel="noopener noreferrer">
              {t('Abrir formulario de contacto')}
            </a>
          </>
        )}
      </div>
      <div ref={hostRef} />
    </Container>
  );
}
